import { Action, createReducer, on } from '@ngrx/store';
import * as SystemActions from './system.actions';

export interface TenantConfig {
  tipo?: string;
  api?: {
    api_geomais?: boolean | string;
  };
  bucket?: string;
  cidade?: string;
  idICAD?: number;
  proj?: string;
  tenantExtent?: any[];
  terms?: {
    title?: string;
    textHtml?: string;
  };
  consultaPreviaPortal?: {
    textoArea?: string;
    campoArea?: string;
  };
  nomeColunaTipologia?: string;
  regressao_multipla_ouv?: string[];
  tabela_unidade?: string;
  checkTerrenoBaldio?: {
    nome_campo: string;
    valor_baldio: string;
  };
  observatorio?: any;
  aliquotaITBI?: number;
}

export interface State {
  tenantConfig: TenantConfig | string | null;
  isLoading: boolean;
  error: any | null;
}

export const initialState: State = {
  tenantConfig: null,
  isLoading: false,
  error: null,
};

const systemReducer = createReducer(
  initialState,
  on(SystemActions.getTenantConfig, (state: State) => ({
    ...state,
    isLoading: true,
  })),
  on(
    SystemActions.getTenantConfigSuccess,
    (state: State, { tenantConfig }: { tenantConfig: TenantConfig }) => ({
      ...state,
      tenantConfig: {
        ...tenantConfig,
        api: {
          ...tenantConfig?.api,
          api_geomais:
            tenantConfig?.api?.api_geomais === 'true' ||
            tenantConfig?.api?.api_geomais === true
            ? true
            : false,
        },
      },
      isLoading: false,
    })
  ),
  on(
    SystemActions.getTenantConfigFail,
    (state: State, { error }: { error: any }) => ({
      ...state,
      tenantConfig: null,
      isLoading: false,
      error,
    })
  )
);

export function reducer(state: State | undefined, action: Action) {
  return systemReducer(state, action);
}

export const getTenantConfig = (state: State) =>
  state.tenantConfig as TenantConfig;
